export default "__VITE_ASSET__B20Jzxs$__"